import React from 'react';
import SaveDatasetAction from '../containers/SaveDatasetAction';
import ViewDatasetAction from '../containers/ViewDatasetAction';
import DatasetWizardAction from '../containers/DatasetWizardAction';

const DatasetWizardActions = ({
  allowSave,
  category,
  code,
  isEditing,
}) => (
  <>
    {allowSave && (<SaveDatasetAction code={code} category={category} isEditing={isEditing} />)}
    <ViewDatasetAction code={code} category={category} />
    <DatasetWizardAction code={code} category={category} />
  </>
);

export default DatasetWizardActions;
